"use client";

import HelpContactCard from "./HelpContactCard";
import HelpRequestForm from "./HelpRequestForm";

export default function HelpSupport({ isAr }: { isAr: boolean }) {
  return (
    <section className="bg-clay-50 najdi-pattern py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,340px)_1fr] gap-6 items-start">
          <HelpContactCard isAr={isAr} />
          <HelpRequestForm isAr={isAr} />
        </div>
      </div>
    </section>
  );
}
